// extracted by mini-css-extract-plugin
export default {"container":"PendingItemsContent__container___fivsn","itemList":"PendingItemsContent__itemList___Je8pp"};